module.exports = __webpack_public_path__ + "static/media/2.fa3921ae.svg";